import React, { ReactNode } from 'react';
import './Patterns.css';

export interface DefinitionListProps {
  /**
   * Visual column count.
   * - `1` = single column, label-then-value stacked (no per-pair grouping)
   * - `2` = label-left / value-right pairs (default)
   * - `3` = three-column dense (label/value × 3 per row)
   */
  columns?: 1 | 2 | 3;
  children: ReactNode;
  /** Optional className extension; rare. */
  className?: string;
}

export interface DataPairProps {
  label: ReactNode;
  value: ReactNode;
}

export const DataPair: React.FC<DataPairProps> = ({ label, value }) => (
  <>
    <dt className="pat-definition-list__label">{label}</dt>
    <dd className="pat-definition-list__value">{value}</dd>
  </>
);

const DefinitionList: React.FC<DefinitionListProps> = ({ columns = 2, children, className }) => (
  <dl
    data-testid="definition-list"
    className={`pat-definition-list pat-definition-list--${columns}${className ? ` ${className}` : ''}`}
  >
    {children}
  </dl>
);

export default DefinitionList;
